
import { useEffect } from 'react';
import Calendar from '@/pages/Calendar';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

export default function Home() {
  useEffect(() => {
    console.log('Home route component mounting...');
  }, []);

  console.log('Home route rendering...');

  return (
    <div className="calendar-page">
      <ProtectedRoute>
        <Calendar />
      </ProtectedRoute>
    </div>
  );
}
